import React from "react";

const CustomBrandingStyle = () => {
  if (!window.templateDefaults.customBranding.css) {
    return null;
  }

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: window.templateDefaults.customBranding.css,
      }}
    />
  );
};

export default CustomBrandingStyle;
